import { Component } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../../lib/api";

const report = (error, componentStack = "") =>
  api.post("/client-errors", {
    message: error?.message || String(error),
    stack: error?.stack || "",
    component_stack: componentStack,
    url: window.location.href,
    user_agent: navigator.userAgent,
  }).catch(() => {});

class Boundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    report(error, info?.componentStack?.slice(0, 2000));
  }

  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="grid min-h-screen place-items-center px-5" data-testid="error-boundary">
        <div className="card-rx max-w-md p-8 text-center">
          <h1 className="text-2xl font-bold text-white">Something went wrong</h1>
          <p className="mt-2 text-sm text-slate-400">Please reload the page. If this keeps happening, contact support.</p>
          <p className="mt-4 break-words rounded-lg bg-white/[0.03] p-3 font-mono-rx text-xs text-slate-500" data-testid="error-boundary-message">
            {String(this.state.error?.message || this.state.error).slice(0, 200)}
          </p>
          <div className="mt-6 flex justify-center gap-3">
            <button onClick={() => window.location.reload()} className="btn-primary" data-testid="error-reload-btn">Reload page</button>
            <button onClick={() => window.location.assign("/")} className="btn-ghost" data-testid="error-home-btn">Home</button>
          </div>
        </div>
      </div>
    );
  }
}

export const ErrorBoundary = ({ children }) => {
  const { pathname } = useLocation();
  return <Boundary resetKey={pathname}>{children}</Boundary>;
};

if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => e.error && report(e.error));
  window.addEventListener("unhandledrejection", (e) => {
    if (!e.reason?.isAxiosError) report(e.reason || "unhandled rejection");
  });
}
